import { render, staticRenderFns } from "./IconExamRegister.vue?vue&type=template&id=36b22f34"
import script from "./IconExamRegister.vue?vue&type=script&lang=ts"
export * from "./IconExamRegister.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports